/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MIMModelDecompositionChartRequestDTO { 
    clientId: number;
    brandId: number;
    conversionType: string;
    dateStart: string;
    dateStop: string;
    resolution: string;
    chartViewBy: MIMModelDecompositionChartRequestDTO.ChartViewByEnum;
}
export namespace MIMModelDecompositionChartRequestDTO {
    export type ChartViewByEnum = 'DecompositionTotalConv' | 'DecompositionTotalConvPerc';
    export const ChartViewByEnum = {
        DecompositionTotalConv: 'DecompositionTotalConv' as ChartViewByEnum,
        DecompositionTotalConvPerc: 'DecompositionTotalConvPerc' as ChartViewByEnum
    };
}


